export function isNoOp(fn): boolean {
  if (typeof fn !== "function") return false;
  const body = fn
    .toString()
    .replace(/\/\/.*$|\/\*[\s\S]*?\*\//gm, "")
    .trim();
  return (
    /^\(\)\s*=>\s*\{\s*\}$/.test(body) ||
    /^\{\s*\}$/.test(body.split("=>").pop()?.trim() || "")
  );
}
